import AltFooter from './AltFooter.jsx'
import './AltFooter.css'
export default AltFooter 